import React, { useContext, useEffect, useState } from 'react';

import ActivityEditModal from '@totem/components/ticketing/details/activities/activityEditModal';
import ActivityTable from '@totem/components/ticketing/details/activities/activityTable';
import TicketContext from '@totem/components/ticketing/details/ticketContext';
import {
  Activity,
  ActivityConfiguration,
} from '@totem/components/ticketing/ticketing';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { TICKET_ENDPOINT } from '@totem/utilities/endpoints';

import '../../ticketing.css';
const Activities = () => {
  const { getApiToken } = useContext(UserProfileContext);
  const { ticket, onCreateActivity } = useContext(TicketContext);
  const [showActivityModal, setShowActivityModal] = useState<boolean>(false);
  const [eligibleActivities, setEligibleActivities] = useState<
    ActivityConfiguration[]
  >([]);
  useEffect(() => {
    if (ticket !== null && ticket.ticket !== null && ticket.ticket.id !== '') {
      fetch(
        `${TICKET_ENDPOINT}/${ticket.ticket.id}/eligibleActivities/${ticket.ticket.organizationId}`,
        {
          method: 'GET',
          headers: new Headers({
            Authorization: `Bearer ${getApiToken()}`,
          }),
        },
      )
        .then((res) => res.json())
        .then((result: ActivityConfiguration[]) => {
          setEligibleActivities(result);
        });
    }
  }, [ticket, getApiToken]);
  const handleActivityEditClose = () => {
    setShowActivityModal(false);
  };
  const handleActivitySubmit = (activity: Activity) => {
    onCreateActivity(activity);

    handleActivityEditClose();
  };
  return (
    ticket !== null &&
    ticket.ticket !== null &&
    ticket.ticket.activity !== null && (
      <>
        <ActivityTable ticket={ticket} />
        {showActivityModal && (
          <ActivityEditModal
            ticket={ticket}
            eligibleActivities={eligibleActivities}
            visible={showActivityModal}
            onSubmit={handleActivitySubmit}
            onClose={handleActivityEditClose}
          />
        )}
      </>
    )
  );
};
export default Activities;
